module.exports = __webpack_public_path__ + "static/wharfinger-9e7d2b16501ee84f38cc5b985240460e.jpg";